import { error, type Load } from '@sveltejs/kit';
import { getChannel, getChannelByHandle } from '../../../firebase/api/channel';
import { getPlans } from '../../../firebase/api/plan';
import { getFeeds } from '../../../firebase/api/feed';
import { get } from '../../../utils/storage';
import type { FeedAbstract } from '../../../firebase/common/feed';

export const load: Load = async ({ params, fetch, url }) => {
  const channelHandle = params.channel_id!;
  const tab = url.searchParams.get('tab') ?? 'feeds';
  const cid = get('currentCID');
  let allow_r18 = false;
  let channelId: string = '';

  {
    try {
      if (cid && typeof (channelId = JSON.parse(cid)) === 'string') {
        const my = await getChannel(channelId, fetch);

        allow_r18 = my?.allow_r18 ?? false;
      }
    } catch (e) {
      console.error(e);
      allow_r18 = false;
    }
  }

  const page = (() => {
    const p = parseInt(url.searchParams.get('p') ?? '1');
    return isNaN(p) || !isFinite(p) ? 1 : p;
  })();

  const channel = await getChannelByHandle(channelHandle, fetch);

  if (channel === null) {
    throw error(404, JSON.stringify({ message: 'channel not found', handle: channelHandle }));
  }

  const feeds =
    tab === 'feeds'
      ? getFeeds(channel.id, 50, 50 * (page - 1), allow_r18, channelId, fetch, get('token'))
          .then(({ count, feeds }) => ({
            count,
            feeds: feeds.map((it) => {
              const { published_at, ...others } = it;
              return {
                ...others,
                published_at: new Date(published_at),
              };
            }),
          }))
          .catch((err) => {
            console.error(err);
            return { feeds: [], count: 0, errored: true };
          })
      : (new Promise((res) => res({ feeds: [], count: 0 })) as Promise<{ feeds: FeedAbstract[]; count: number }>);

  const plans = getPlans(channel.id, fetch).catch((err) => {
    console.error(err);
    return { errored: true };
  });

  return {
    channel,
    page,
    tab,
    streamed: {
      plans,
      feeds,
    },
  };
};
